/* ORAVIE - interactions. Transform/opacity only. No dependencies. */
(function () {
  'use strict';
  var each = function (l, f) { Array.prototype.forEach.call(l, f); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Full-bleed sections are sized with 100vw, which includes the classic
     scrollbar gutter on desktop. Publish the real gutter width so the CSS
     can subtract it and no phantom horizontal scroll appears. */
  function scrollbar() {
    var set = function () {
      var w = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--sbw', (w > 0 ? w : 0) + 'px');
    };
    set();
    window.addEventListener('resize', set, { passive: true });
    window.addEventListener('load', set, { passive: true });
  }

  function drawer() {
    var d = document.getElementById('drawer');
    if (!d) return;
    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = d.querySelectorAll('[data-drawer-close]');
    each(d.querySelectorAll('.drawer__list a'), function (a, i) { a.style.setProperty('--i', i); });
    function set(open) {
      d.setAttribute('data-open', open ? 'true' : 'false');
      document.body.setAttribute('data-lock', open ? 'true' : 'false');
      each(openers, function (b) {
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.setAttribute('data-open', open ? 'true' : 'false');
      });
      if (open) { var f = d.querySelector('a'); if (f) f.focus(); }
    }
    each(openers, function (b) { b.addEventListener('click', function () { set(d.getAttribute('data-open') !== 'true'); }); });
    each(closers, function (b) { b.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.getAttribute('data-open') === 'true') set(false);
    });
  }

  function reveal() {
    var items = document.querySelectorAll('[data-r]');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      each(items, function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    each(items, function (el) { io.observe(el); });
  }

  function gallery() {
    var g = document.querySelector('[data-gal]');
    if (!g) return;
    var slides = g.querySelectorAll('[data-slide]');
    var thumbs = g.querySelectorAll('[data-thumb]');
    var live = g.querySelector('[data-gal-count]');
    function show(i) {
      each(slides, function (s, n) { s.setAttribute('data-on', n === i ? 'true' : 'false'); });
      each(thumbs, function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (live) live.textContent = (i + 1) + ' / ' + slides.length;
    }
    each(thumbs, function (t, i) { t.addEventListener('click', function () { show(i); }); });
  }

  function qty() {
    each(document.querySelectorAll('[data-qty]'), function (box) {
      var input = box.querySelector('input');
      if (!input) return;
      each(box.querySelectorAll('[data-step]'), function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var val = parseInt(input.value, 10);
          if (isNaN(val)) val = min;
          input.value = Math.max(min, val + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function cartLines() {
    each(document.querySelectorAll('[data-line] input[name="updates[]"]'), function (input) {
      input.addEventListener('change', function () {
        var f = input.closest('form');
        if (f) f.submit();
      });
    });
  }

  /* Sticky purchase bar: visible whenever the real Add to cart is off screen,
     including first paint, so an ad visitor always has a live CTA. */
  function sticky() {
    var bar = document.getElementById('buybar');
    var form = document.getElementById('pform');
    if (!bar || !form) return;
    var atc = form.querySelector('[type="submit"]');
    if (!atc) return;
    function set(v) { bar.setAttribute('data-on', v ? 'true' : 'false'); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { set(!e.isIntersecting); });
      }, { threshold: 0.55 }).observe(atc);
    } else { set(true); }
    var proxy = bar.querySelector('[data-buy]');
    if (proxy) proxy.addEventListener('click', function () { atc.click(); });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  scrollbar();
  ready(function () { drawer(); reveal(); gallery(); qty(); cartLines(); sticky(); });
})();
